import { getFormatText, getReverseDate } from "@/scripts/formatDate";

export class OrderParent {
  constructor() {
    this.list = []
  }

  addOrder(item) {

    const body = item
    body.orderDate = getReverseDate(body.orderDate)
    body.effectiveDate = getReverseDate(body.effectiveDate)

    this.list.push(Order.buildFromAPI(body))
  }

  updateOrder(item) {
    const index = this.list.findIndex(el => el.id === item.id)

    const body = item
    body.orderDate = getReverseDate(body.orderDate)
    body.effectiveDate = getReverseDate(body.effectiveDate)

    this.list.splice(index, 1, Order.buildFromAPI(item))
  }

  removeOrder(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => Order.buildFromAPI(el))
    }
    return this
  }
}

export class Order {
  constructor() {
    this.id = null
    this.orderNumber = null
    this.effectiveDate = null
    this.orderDate = null
    this.speciality = null
    this.paidForm = null
  }

  get effectiveDateText () {
    return this.effectiveDate && getFormatText(this.effectiveDate)
  }

  get orderDateText () {
    return this.orderDate && getFormatText(this.orderDate)
  }


  getForAPI() {
    return {
      id: this.id,
      orderNumber: this.orderNumber,
      orderDate: getReverseDate(this.orderDate),
      effectiveDate: getReverseDate(this.effectiveDate),
      speciality: this.speciality,
      paidForm: this.paidForm,
    }
  }

  static buildFromAPI(obj) {
    const _this = new Order()
    if (obj) {
      _this.id = obj.id
      _this.orderNumber = obj.orderNumber
      _this.orderDate = obj.orderDate
      _this.effectiveDate = obj.effectiveDate
      _this.speciality = obj.speciality
      _this.paidForm = obj.paidForm
    }
    return _this
  }
}